import { render, staticRenderFns } from "./NationalExam.vue?vue&type=template&id=5dbabc52&"
import script from "./NationalExam.vue?vue&type=script&lang=js&"
export * from "./NationalExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports